import {
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import { Modal, Row, Col } from "react-bootstrap";
import { AiFillEdit, AiFillDelete } from "react-icons/ai";

import { server } from "../../../common";
import { AxiosError } from "axios";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { useSelectAccess } from "../../../store/stateFunctions";
import useQuickLook from "../../../quicklook/useQuickLook";

const initialValues = {
  org_name: "",
  email: "",
  statement: "",
  industry_type: "",
  category: "",
};

const swalalert = withReactContent(Swal);

const AddIndustryInnovation = ({ role }) => {
  const user = useSelectAccess("Industry User");
  const displayFile = useQuickLook();

  const [show, setShow] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => {
    setIsEditMode(false);
    setSelectedData(null);
    formik.setValues(initialValues);
    setShow(true);
  };

  const [data, setData] = useState([]);
  const [selectedData, setSelectedData] = useState(null);

  const handleShowEdit = (data) => {
    setSelectedData(data);
    setIsEditMode(true);
    setShow(true);
  };

  useEffect(() => {
    getData();
    // Check if in edit mode and selectedData is available
    if (isEditMode && selectedData) {
      formik.setValues({
        org_name: selectedData.org_name,
        email: selectedData.email,
        statement: selectedData.statement,
        category: selectedData.category,
        industry_type: selectedData.industry_type,
      });
    }
  }, [isEditMode, selectedData]);

  // Get Gallery
  const getData = () => {
    server
      .get("/ideas/getallinnovative_ideas", {
        headers: {
          "Content-Type": "application/json",
          Authorization: user.authToken,
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setData(response.data);
        }
      })
      .catch(function (error) {
        if (error instanceof AxiosError && error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
      });
  };

  // Delete gallery
  const handleDelete = (data) => {
    swalalert
      .fire({
        title: "Delete Confirmation!",
        text: `Are You Sure That You Want To Delete ${data.org_name} ?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        confirmButtonClass: "btn btn-success",
        cancelButtonClass: "btn btn-danger",
        buttonsStyling: true,
      })
      .then(function (swalObject) {
        if (swalObject.isConfirmed) {
          server
            .delete(`/ideas/deleteinnovative_ideas/${data.id}`, {
              headers: {
                "Content-Type": "application/json",
                Authorization: user.authToken,
              },
            })
            .then(function (response) {
              console.log("api response", response.data);
              if (response.status === 200 || response.status === 201) {
                swalalert.fire(
                  "Deleted!",
                  "Innovative Idea has been deleted.",
                  "success"
                );
                getData();
              }
            })
            .catch((error) => {
              toast.error(error.response.data.message);
            });
        } else {
          swalalert.fire(
            "Cancelled",
            "Your imaginary file is safe :)",
            "error"
          );
        }
        //success method
      });
  };

  // update news
  const handleUpdate = (values) => {
    server
      .put(`/ideas/updateinnovative_ideas/${values.id}`, values, {
        headers: {
          "Content-Type": "application/json",
          Authorization: user.authToken,
        },
      })
      .then(function (response) {
        formik.resetForm();
        getData();
        toast.success("Innovative Idea Updated successfully");
        handleClose();
      })
      .catch(function (error) {
        if (error.response?.data?.message)
          toast.error(error.response.data.message);
        else if (error.response?.data?.error) {
          toast.error(error.response.data.error);
        } else toast.error("Failed to connect to server");
      });
  };

  //add
  const formik = useFormik({
    initialValues: isEditMode ? selectedData : initialValues,
    validationSchema: Yup.object({
      org_name: Yup.string().required("Enter a Organization Name"),
      statement: Yup.string().required("Enter a Problem Statement"),
      email: Yup.string().required("Enter a Email Id"),
      category: Yup.string().required("Select a Problem Category"),
      industry_type: Yup.string().required("Enter a Theme"),
    }),
    onSubmit: (values, action) => {
      if (isEditMode) {
        handleUpdate({ ...values, id: selectedData.id });
      } else {
        server
          .post("/ideas/addinnovative_ideas", values, {
            headers: {
              "Content-Type": "application/json",
              Authorization: user.authToken,
            },
          })
          .then(function (response) {
            if (response.status === 200 || response.status === 201) {
              toast.success("Innovative Idea Added successfully");
              formik.resetForm();
              handleClose();
              getData();
            }
          })
          .catch(function (error) {
            if (error.response?.data?.message)
              toast.error(error.response.data.message);
            else if (error.response?.data?.error) {
              toast.error(error.response.data.error);
            } else toast.error("Failed to connect to server");
          });
      }
    },
  });

  return (
    <>
      {console.log(formik.values)}
      {console.log(formik.errors)}

      <div className="container">
        <div className="d-flex position-relative mb-3 justify-content-center ">
          <h5 className="m-auto text-center">Industry Challenges</h5>
          <Button variant="contained" color="info" onClick={handleShow}>
            Industry Challenges
          </Button>

          <Modal show={show} onHide={handleClose} size="lg">
            <Modal.Header closeButton>
              <Modal.Title>
                <h4> Industry Challenges Submission Form</h4>
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>
                Are you facing daily challenges in your industry that seem to
                defy conventional solutions? We believe in the power of
                innovation, and that's why we've created this platform to
                connect industries with the brilliant minds of college students.
                Submit your industry challenges today and witness the
                transformative power of collaboration! Empower students, drive
                innovation, and shape the future of your industry.
              </p>
              <form onSubmit={formik.handleSubmit}>
                <Row>
                  <Col>
                    <div className="form-outline mb-2">
                      <TextField
                        name="org_name"
                        margin="dense"
                        type="text"
                        placeholder=" Enter the name of your organization"
                        variant="outlined"
                        label=" Organisation Name"
                        value={formik.values.org_name}
                        onChange={formik.handleChange}
                        fullWidth
                        required
                      ></TextField>
                      {formik.errors.org_name ? (
                        <p className="text-danger">{formik.errors.org_name}</p>
                      ) : null}
                    </div>
                    {/* Email */}
                    <div className="form-outline mb-2">
                      <TextField
                        name="email"
                        margin="dense"
                        type="text"
                        placeholder="Enter your email address"
                        variant="outlined"
                        label=" Email Id"
                        value={formik.values.email}
                        onChange={formik.handleChange}
                        fullWidth
                        required
                      ></TextField>
                      {formik.errors.email ? (
                        <p className="text-danger">{formik.errors.email}</p>
                      ) : null}
                    </div>
                  </Col>
                  <Col>
                    <div className="form-outline mb-2">
                      <TextField
                        name="industry_type"
                        margin="dense"
                        type="text"
                        placeholder="Industry Type"
                        variant="outlined"
                        label="Specify the industry type"
                        value={formik.values.industry_type}
                        onChange={formik.handleChange}
                        fullWidth
                        required
                      ></TextField>
                      {formik.errors.industry_type ? (
                        <p className="text-danger">
                          {formik.errors.industry_type}
                        </p>
                      ) : null}
                    </div>
                    <div className="mb-2">
                      <FormControl
                        fullWidth
                        required
                        className="mt-2"
                        id="demo-simple-select-label"
                      >
                        <InputLabel>Choose Category</InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          name="category"
                          value={formik.values.category}
                          onChange={formik.handleChange}
                        >
                          <MenuItem value="software">Software</MenuItem>
                          <MenuItem value="hardware">Hardware</MenuItem>
                          <MenuItem value="other">Other</MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                  </Col>
                </Row>
                <div className="form-outline mb-2">
                  <TextField
                    name="statement"
                    margin="dense"
                    type="text"
                    placeholder="Describe the industry challenge you're addressing"
                    variant="outlined"
                    label="Problem Statement"
                    value={formik.values.statement}
                    onChange={formik.handleChange}
                    fullWidth
                    required
                  ></TextField>
                  {formik.errors.statement ? (
                    <p className="text-danger">{formik.errors.statement}</p>
                  ) : null}
                </div>
                {/* <div className="mb-2">
                  <FormControl fullWidth required className="mt-2">
                    <InputLabel>Themes</InputLabel>
                    <Select>
                      <MenuItem value=" 1">All</MenuItem>
                      <MenuItem value=" 2">
                        Agriculture,Foodchain,Rural Development
                      </MenuItem>
                      <MenuItem value=" 3">
                        Blockchain &amp; Cybersecurity
                      </MenuItem>
                      <MenuItem value=" 4">
                        Clean &amp; Green Technology
                      </MenuItem>
                      <MenuItem value=" 5">Fitness &amp; Sports</MenuItem>
                      <MenuItem value=" 6">Heritage &amp; Culture</MenuItem>
                      <MenuItem value=" 7">Miscellaneous</MenuItem>
                      <MenuItem value=" 8">
                        Renewable / Sustainable Energy
                      </MenuItem>
                      <MenuItem value=" 9">Robotics and Drones</MenuItem>
                      <MenuItem value=" 10">Robotics and Drones</MenuItem>
                      <MenuItem value=" 11">Smart Vehicles</MenuItem>
                      <MenuItem value=" 12">Travel &amp; Tourism</MenuItem>
                      <MenuItem value=" 13">
                        Transportation &amp; Logistics
                      </MenuItem>
                    </Select>
                  </FormControl>
                </div>
                <div className="mb-2">
                  <FormControl fullWidth required className="mt-2">
                    <InputLabel>Category</InputLabel>
                    <Select>
                      <MenuItem value=" 1">Software</MenuItem>
                      <MenuItem value=" 2">Hardware</MenuItem>
                    </Select>
                  </FormControl>
                </div> */}

                <div className="pt-1 mb-2 ">
                  <Button variant="contained" type="submit">
                    Submit
                  </Button>
                  <Button
                    className="float-end"
                    variant="contained"
                    color="warning"
                    onClick={handleClose}
                  >
                    Close
                  </Button>
                </div>
              </form>
            </Modal.Body>
          </Modal>
        </div>

        <div className="container" style={{ overflowX: "scroll" }}>
          <table className="table table-striped border">
            <thead>
              <tr>
                <th scope="col">Sr. No.</th>
                <th scope="col">Organization Name</th>
                <th scope="col">Email</th>
                <th scope="col">Problem Statement</th>
                <th scope="col">Industry Type</th>
                <th scope="col">Status</th>
                <th scope="col">Update</th>
                <th scope="col">Delete</th>
              </tr>
            </thead>
            <tbody>
              {data?.map((item, index) => {
                return (
                  <tr key={item.id}>
                    <th scope="row">{index + 1}</th>
                    <td>{item.org_name}</td>
                    <td>{item.email}</td>
                    <td>{item.statement}</td>
                    <td>{item.industry_type}</td>
                    <td>{item.status}</td>
                    <td>
                      <div className="btn banner text-white">
                        <AiFillEdit onClick={() => handleShowEdit(item)} />
                      </div>
                    </td>
                    <td>
                      <div className="btn banner text-white">
                        <AiFillDelete onClick={() => handleDelete(item)} />
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default AddIndustryInnovation;
